import { Component, OnInit, Input, Optional, Self } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgControl } from '@angular/forms';
import { QuestionOperator } from 'app/enums/question-operator.enum';
import { ComparableOperator, Question } from 'app/models/form';
import { BaseAnswerTypeComponent } from '../base-answer-type.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent extends BaseAnswerTypeComponent<number | number[]> implements OnInit {
  formGroup: UntypedFormGroup;
  // @Input() controlName: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() minDate: Date = null;
  @Input() detailMode: boolean = false;
  @Input() readonly: boolean;
  @Input() required: boolean;
  @Input() operatorAvailable: boolean = false;
  @Input() question: Question;

  QUESTION_OPERATOR = QuestionOperator;
  operatorSelected: number = QuestionOperator.Equals;
  operatorsDisable: number[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    @Self()
    @Optional()
    ngControl?: NgControl,
  ) {
    super(ngControl);
    this.formGroup = this.fb.group({
      date: null
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

    this.ngControl.control.valueChanges.subscribe(changes => {
      if(!changes){
        this.operatorSelected = QuestionOperator.Equals;
        this.operatorsDisable = [];
      }
    });

    if(this.readonly){
      this.formGroup.disable();
    }

    if(this.required && !this.ngControl.control?.value){
      this.ngControl.control.setErrors({'dateRequired': true});
    }

    if(this.ngControl.control?.value){
      this.formGroup.get('date').setValue(this.ngControl.control?.value);
      if(this.question?.questionOperatorId){
        this.operatorSelected = this.question?.questionOperatorId;
      }
    }
    
    this.formGroup.valueChanges.subscribe(data => {
      let controlValue = data;

      if(this.operatorAvailable){
        controlValue = [data.date, this.operatorSelected];
      }

      this.ngControl.control.setValue(controlValue);
    });

    this.ngControl.control?.valueChanges.subscribe(
      changes => {
        if(!changes && this.formGroup.get('date').value){
          this.formGroup.get('date').setValue(this.ngControl.control?.value);
        }
      });
  }

  handleKeyDown(e: KeyboardEvent){
    if(e.code !== "Backspace"){
      e.preventDefault();
      return;
    }
  }

  handleQuestionOperator(operator: MatRadioChange){
    this.operatorSelected = operator.value;
    this.formGroup.get('date').setValue(this.formGroup.get('date').value);
  }

  getError(errorCode: string) {
    // Enables the control for getting the error properly

    // this.formGroup.get(this.controlName).enable();
    // const hasError: boolean = this.formGroup.get(this.controlName).hasError(errorCode);
    // this.formGroup.get(this.controlName).disable();
    // return hasError;
  }

  AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(";").map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }
  
}
